module.exports = __webpack_public_path__ + "static/media/音乐模块.4a88bcdf.png";